import {
  buildOrganizationNode,
  getSchemaIds,
} from 'utils/structuredData/organization';

export const buildHomepageStructuredData = ({
  siteUrl,
  siteName,
  description,
  logoUrl,
  alternateName,
  parentOrganization,
  contactPoint,
  address,
}) => {
  const { homeUrl, orgId, siteId, logoId } = getSchemaIds(siteUrl);
  const pageId = `${homeUrl}#webpage`;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      buildOrganizationNode({
        siteUrl,
        siteName,
        description,
        logoUrl,
        alternateName,
        parentOrganization,
        contactPoint,
        address,
      }),
      {
        '@type': 'WebSite',
        '@id': siteId,
        url: homeUrl,
        name: siteName,
        description,
        publisher: { '@id': orgId },
        inLanguage: 'en',
      },
      {
        '@type': 'WebPage',
        '@id': pageId,
        url: homeUrl,
        name: siteName,
        description,
        isPartOf: { '@id': siteId },
        about: { '@id': orgId },
        primaryImageOfPage: { '@id': logoId },
        inLanguage: 'en',
      },
    ],
  };
};
